import type React from 'react';
import { Link } from 'react-router-dom';
import { MessageScreen, messageScreenActionClassName } from '../../components';
import { ROUTES } from '../../routes';

/** Any route the identity app does not serve. */
export const NotFoundPage: React.FC = () => (
  <MessageScreen
    title="Page not found"
    mood="surprised"
    action={
      <Link className={messageScreenActionClassName} to={ROUTES.home}>
        Go to your account
      </Link>
    }
  >
    <p>That page doesn&apos;t exist. It may have moved, or the link may be mistyped.</p>
  </MessageScreen>
);
